import { ObjectSchema } from "schemaComponents";

const schema: ObjectSchema = {
  schemaType: "object",
  properties: [
    {
      title: "キャンペーン名",
      propertyName: "campaignName",
      schema: {
        schemaType: "text",
        required: true,
      },
    },
    {
      title: "ロゴ",
      propertyName: "logoURL",
      schema: {
        schemaType: "image",
      },
    },
  ],
};
export default schema;
